// Lib
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_FULL } from '@/lib/gridElements/size';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    YOUTUBE
} from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementRateHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.group.avg_engagement_rate_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.group.avg_engagement_rate_history_name'
    },
    disableGraphData: ['count_posts'],
    id: 'average_engagement_rate_history',
    color: {
        value: 'green'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    tooltip: 'chart.group.avg_engagement_rate_history_tooltip',
    size: SIZE_FULL,
    type: 'chart',
    isXAxisDate: true,
    element: LineChart,
    hasComparativeView: true,
    aggregatedNetworks: [INSTAGRAM, FACEBOOK, LINKEDIN, TIKTOK_BUSINESS, YOUTUBE, PINTEREST]
};
